import { PipeTransform } from '@angular/core';
// Takes a pure function and it's inputs for computation and use in a template
// This prevents the function from being evaluated on every change detection cycle,
// and instead only when inputs change
var PureFunctionPipe = /** @class */ (function () {
    function PureFunctionPipe() {
    }
    PureFunctionPipe.prototype.transform = function (fnc) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        return fnc.apply(void 0, args); // compute the function
    };
    return PureFunctionPipe;
}());
export { PureFunctionPipe };
